import React, {useEffect, useState} from 'react';
import config from "../../../../../config";
import {saveHotkeysConfig} from "../../../../../services/company/api";
import Translate from "../../../../../components/Translate";
import BlueButton from "../../../../../components-new/buttons/BlueButton";
import {titleStyles} from "../../../../../utils/General";


const styles2 = {
    container: {
        width: '100%',
        maxWidth: '600px',
        padding: '20px',
        borderRadius: '10px',
        margin: 'auto',
    },
    row: {
        display: 'flex',
        alignItems: 'center',
        marginBottom: '10px',
        gap: '10px',
    },
    label: {
        fontSize: '16px',
        lineHeight: '20px',
        marginLeft: '20px',
        fontWeight: 'inherit',
        color: '#A4ADC1',
    },
    hotkeyBox: {
        flex: 2,
        padding: '6px 10px',
        border: '1px solid #ccc',
        borderRadius: '4px',
        cursor: 'pointer',
        userSelect: 'none',
        textAlign: 'center',
        backgroundColor: '#f9f9f9',
    },
    editing: {
        borderColor: '#1890ff',
        backgroundColor: '#e6f7ff',
    },
};

const reservedHotkeys = [
    'Ctrl+T', 'Ctrl+W', 'Ctrl+N',
    'Ctrl+Shift+I', 'F12', 'Ctrl+Shift+R', 'Ctrl+C', 'Ctrl+V'
];

const Hotkeys = ({hotkeys = [], setHotkeys, addNotification, styles}) => {
    const [localHotkeys, setLocalHotkeys] = useState([]);
    const [editingIndex, setEditingIndex] = useState(null);
    const [tempHotkey, setTempHotkey] = useState('');
    const [error, setError] = useState('');

    useEffect(() => {
        setLocalHotkeys(hotkeys);
    }, [hotkeys]);

    useEffect(() => {
        const handleKeyDown = (e) => {
            if (editingIndex === null) return;

            e.preventDefault();

            const keys = [];
            if (e.ctrlKey) keys.push('Ctrl');
            if (e.shiftKey) keys.push('Shift');
            if (e.altKey) keys.push('Alt');
            if (e.metaKey) keys.push('Meta');

            const key = e.code === 'Space' ? 'Space' : (e.key.length === 1 ? e.key.toUpperCase() : e.key);
            if (!['CONTROL', 'SHIFT', 'ALT', 'META'].includes(key.toUpperCase())) {
                keys.push(key);
            }

            const combo = keys.join('+');
            setTempHotkey(combo);

            if (reservedHotkeys.includes(combo)) {
                setError("hotkeyReservedError");
                addNotification('hotkeyReservedError', config.notificationLevels.error);
            } else {
                setError('');
                const updated = [...localHotkeys];
                updated[editingIndex].hotkey = combo;
                setLocalHotkeys(updated);
                setHotkeys(updated);
            }
        };

        window.addEventListener('keydown', handleKeyDown, {capture: true});
        return () => window.removeEventListener('keydown', handleKeyDown, {capture: true});
    }, [editingIndex, addNotification, localHotkeys, setHotkeys]);

    const handleSaveAll = async () => {
        const usedHotkeys = new Set();
        for (let hk of localHotkeys) {
            if (hk.hotkey.length === 1) {
                addNotification('hotkeyMustIncludeModifier', config.notificationLevels.error);
                return
            }
            if (!hk.hotkey) {
                addNotification('someHotkeysAreEmpty', config.notificationLevels.error);
                return;
            }
            if (reservedHotkeys.includes(hk.hotkey)) {
                addNotification(`hotkeyReservedError`, config.notificationLevels.error);
                return;
            }
            if (usedHotkeys.has(hk.hotkey)) {
                addNotification('duplicateHotkeyFound', config.notificationLevels.error);
                return;
            }
            usedHotkeys.add(hk.hotkey);
        }

        try {
            const requests = localHotkeys.map(({action, hotkey}) => ({action, hotkey}));
            await saveHotkeysConfig(requests);
            addNotification('saved', config.notificationLevels.success);
        } catch (err) {
            console.error(err);
            addNotification('somethingWentWrong', config.notificationLevels.error);
        }
    };

    return (
        <div style={styles.fullWidthContainer}>
            <div style={styles.fullWidthCard}>
                <h2 style={titleStyles.title}>
                    <Translate text="hotkeys"/>
                </h2>
                <br/>

                <div style={styles2.container}>
                    {localHotkeys.map((hk, index) => (
                        <div key={index} style={styles2.row}>
                            <div style={styles2.label}><Translate text={hk.action}/></div>
                            <div
                                style={{...styles2.hotkeyBox, ...(editingIndex === index ? styles2.editing : {})}}
                                onClick={() => {
                                    setEditingIndex(editingIndex === index ? null : index);
                                    setTempHotkey('');
                                    setError('');
                                }}
                            >
                                {hk.hotkey}
                            </div>
                        </div>
                    ))}
                    <div style={{textAlign: 'center', marginTop: '20px'}}>
                        <BlueButton
                            width={'200px'}
                            onClick={handleSaveAll}
                            disabled={!!error}
                        >
                            <Translate text={'save'}/>
                        </BlueButton>
                    </div>
                </div>


            </div>
        </div>
    );
};

export default Hotkeys;



// WEBPACK FOOTER //
// ./src/scenes/dashboard/components/my-history/components/Hotkeys.jsx